var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuperCoin = function SvgSuperCoin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5 10c-2.80359583 0-5-2.16995833-5-4.939125C0 2.27041667 2.2431125 0 5 0c2.756875 0 5 2.27041667 5 5.060875C10 7.83004167 7.80358333 10 5 10z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75645833 5.754625C8.75645833 7.854875 7.075 9.45395833 5 9.45395833c-2.07495 0-3.7552375-1.59908333-3.7552375-3.69933333 0-2.10020833 1.68145417-3.8021375 3.7552375-3.8021375 2.07383333 0 3.75645833 1.70310833 3.75645833 3.8021375z",
    fill: "#FFC30D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10c-2.80359583 0-5-2.16995833-5-4.939125C0 2.27041667 2.2431125 0 5 0c2.756875 0 5 2.27041667 5 5.060875C10 7.83004167 7.80358333 10 5 10z",
    fill: "#FD0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99945783.99515417C2.68277033.99515417.798137 2.90272917.798137 5.247625c0 2.31295833 1.8461 4.12479167 4.20132083 4.12479167 2.35520834 0 4.20129167-1.81066667 4.20129167-4.12479167 0-2.34489583-1.884625-4.25247083-4.20129167-4.25247083z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0332495.76505C2.71659117.76505.83195783 2.672625.83195783 5.0175c0 2.31295833 1.8461 4.12479167 4.20129167 4.12479167 2.35520833 0 4.20133387-1.81183334 4.20133387-4.12479167C9.2357495 2.672625 7.3511245.76505 5.0332495.76505z",
    fill: "#F0A700",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99945783.91712917c-2.3166875 0-4.20132083 1.907575-4.20132083 4.25245416 0 2.31295834 1.8461 4.12479167 4.20132083 4.12479167 2.35520834 0 4.20129167-1.81183333 4.20129167-4.12479167 0-2.34487916-1.884625-4.25245416-4.20129167-4.25245416z",
    fill: "#FFC000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.85988251 5.08091667c-.01162051 2.3425 1.85432949 4.25125 4.16865866 4.26309224.56166666.00115776 1.118625-.11230058 1.63475-.33330058 2.13804166-.91008333 3.14225-3.4015 2.243125-5.56555C8.2524995 1.88624167 6.74504117.8698125 5.0717495.86148648 2.75741617.84972083.87161617 2.7383875.85988251 5.08091667zM2.1186495 2.16274583c.77650417-.78477916 1.81107083-1.21616666 2.90985-1.21616666 1.09995833 0 2.13216667.43020833 2.909875 1.21498333.77766667.78477917 1.20504167 1.826025 1.20504167 2.9358125 0 1.10979167-.42854167 2.15104167-1.20504167 2.93583333C7.16183283 8.818 6.12729117 9.249375 5.0284995 9.249375c-1.09877917 0-2.13334583-.431375-2.90985-1.21616667C1.34214117 7.24841667.91360367 6.206.91360367 5.097375c0-1.10860417.4285375-2.14985417 1.20504583-2.93462917z",
    fill: "#D89309",
    opacity: 0.72
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5.902625 1.09326667L2.5759 4.7725c-.4285375.47395833-.17632083 1.142875.45772917 1.12633333l1.9196625.01775c.09691666 0 .17516666.080375.174.17845834 0 .015375-.00233334.03070833-.00583334.04608333l-.77066666 2.84954167L7.650625 5.369375c.413375-.453875.09575-1.189-.51495833-1.189l-1.89395834.03545833c-.09691666.002375-.17633333-.07564583-.17866666-.17374166 0-.01772917.00233333-.03545834.007-.0531875.20204166-.71859167.806875-2.8696375.83258333-2.8956375z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuperCoin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/super-coin.8e52cd1f.svg";
export { ForwardRef as ReactComponent };